var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", staticStyle: { flex: "0 0" } },
    [
      _c("v-data-table", {
        staticClass: "ingestion-results-changes five-items",
        attrs: {
          headers: _vm.headers,
          "disable-initial-sort": "",
          items: _vm.trackedChanges,
          "rows-per-page-items": [5],
          "no-data-text": "There are no changes in your data.",
        },
        scopedSlots: _vm._u([
          {
            key: "headers",
            fn: function (props) {
              return [
                _c(
                  "tr",
                  _vm._l(props.headers, function (header, index) {
                    return _c(
                      "th",
                      {
                        key: `header-${index}`,
                        class: [`pl-${index == 0 ? "4" : "2"} pr-2`],
                        style: `text-align: ${header.align}`,
                      },
                      [_vm._v(_vm._s(header.text))]
                    )
                  }),
                  0
                ),
              ]
            },
          },
          {
            key: "items",
            fn: function (props) {
              return [
                _c(
                  "tr",
                  [
                    props.item.type == _vm.changeTypes.dirty
                      ? [
                          _c(
                            "td",
                            { staticClass: "pl-4 pr-2" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-0",
                                  attrs: { small: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setSelected(
                                        props.item.location
                                      )
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(props.item.displayName))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "px-2" },
                            [
                              _c(
                                "v-input",
                                {
                                  staticClass:
                                    "teal--text text--darken-3 dirtyInput",
                                  attrs: {
                                    messages: [
                                      props.item.initialValue || "blank",
                                    ],
                                  },
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "prepend" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "icon-shadow",
                                          attrs: {
                                            color: _vm.getStatus(props.item)
                                              .color,
                                          },
                                        },
                                        [_vm._v("edit")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(props.item.value) +
                                      "\n            "
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ]
                      : [
                          _c(
                            "td",
                            { staticClass: "pl-4 pr-2" },
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { left: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  staticClass: "ma-0",
                                                  attrs: { small: "" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.setSelected(
                                                        props.item.location
                                                      )
                                                    },
                                                  },
                                                },
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  _vm._s(props.item.displayName)
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(props.item.fullName)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "px-2" },
                            [
                              _c(
                                "v-input",
                                {
                                  staticClass: "dirtyRow",
                                  attrs: { "hide-details": "" },
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "prepend" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "icon-shadow",
                                          attrs: {
                                            color: props.item.iconColor,
                                          },
                                        },
                                        [_vm._v(_vm._s(props.item.icon))]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(props.item.text) +
                                      "\n            "
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "px-2" },
                      [
                        props.item.canUndo
                          ? _c(
                              "v-btn",
                              {
                                staticClass: "ma-0 pa-0 undo-change",
                                attrs: {
                                  small: "",
                                  color: "secondary lighten-1",
                                },
                                on: {
                                  click: function ($event) {
                                    return props.item.undo()
                                  },
                                },
                              },
                              [_c("v-icon", [_vm._v("undo")])],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }